module.exports = __webpack_public_path__ + "static/media/so-do-to-chuc-Daedong-2018.a6aba34c.png";